<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <v-btn :disabled="disabled" :dark="disabled" color="white" text v-on="on">
        <div class="icon-button-container">
          <div class="icon-button-text">
            Skapa nytt möte
          </div>
          <div class="icon-button-icon">
            <v-icon right>mdi-plus</v-icon>
          </div>
        </div>
      </v-btn>
    </template>
    <v-card v-if="organization">
      <v-card-title class="color-a">
        Lägg till möte för {{ organization.name }}
      </v-card-title>
      <v-card-text>
        <meeting-form ref="form" :organization="organization"></meeting-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="create"
          >Lägg till</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MeetingForm from "@/components/meetings/MeetingForm.vue";

export default {
  props: {
    organization: Object,
    disabled: Boolean
  },
  components: { MeetingForm },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    close() {
      this.$refs.form.close();
      this.dialog = false;
    },
    async create() {
      let payload = {
        organization: this.organization,
        ...this.$refs.form.form
      };
      const success = await this.$store.dispatch(
        "meetings/createMeeting",
        payload
      );
      if (success) {
        this.close();
      }
    }
  }
};
</script>

<style></style>
